const appCanBeStarted = state => state.rootUrl !== null
const getEnv = state => state.env
const getRootUrl = state => state.rootUrl
const isLoading = state => state.loading
const getSettings = state => state.settings
const getGA = state => {
  return state.settings.filter(el => el.type === 'ga')[0] || 'UA-XXX-X'
}

export default {
  appCanBeStarted,
  getEnv,
  getRootUrl,
  isLoading,
  getSettings,
  getGA
}



// WEBPACK FOOTER //
// ./src/store/modules/app/getters.js